import { render, staticRenderFns } from "./NewsLiveWidget.vue?vue&type=template&id=6f3a5a5e&scoped=true&"
import script from "./NewsLiveWidget.vue?vue&type=script&lang=js&"
export * from "./NewsLiveWidget.vue?vue&type=script&lang=js&"
import style0 from "./NewsLiveWidget.vue?vue&type=style&index=0&id=6f3a5a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a5a5e",
  null
  
)

export default component.exports